export class HttpNoContentResponse {
    static readonly CODE = 204;
}
